var type = function type(x) {
  return Object.prototype.toString.call(x).slice(8, -1);
};
var get = function get(path, obj, defaultValue) {
  var head = path[0];
  var tail = path.slice(1);
  if (!tail.length) {
    var res = obj[head];
    var isEmpty = type(res) === 'Object' && Object.keys(res).length === 0 || type(res) === 'Null' || type(res) === 'Undefined';
    return isEmpty ? defaultValue : obj[head];
  }
  return get(tail, obj[head], defaultValue);
};
var withMinAndMaxMedia = function withMinAndMaxMedia(x, y) {
  return "@media (min-width: ".concat(x, ") and (max-width: ").concat(y, ")");
};
var makeErrorMessage = function makeErrorMessage(breakName, breaks) {
  return "'".concat(breakName, "' is invalid breakpoint name. Use '").concat(Object.keys(breaks).join(', '), "'.");
};
module.exports = {
  type: type,
  get: get,
  withMinAndMaxMedia: withMinAndMaxMedia,
  makeErrorMessage: makeErrorMessage
};